import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseDirective } from '@egym/ngx-adm-int';
import { GymFinderService } from '../../../service/gymfinder.service';
import { Gym } from '../../../model/gym';

@Component({
  selector: 'gymfinder-gym-import',
  templateUrl: './gym-import.component.html',
  styleUrls: ['./gym-import.component.scss'],
  standalone: false,
})
export class GymImportComponent extends BaseDirective<void> {
  @Input()
  gymId: string;

  @Output()
  gymChange = new EventEmitter<Gym>();

  importForm = new FormGroup({
    slug: new FormControl<string>(''),
  });

  constructor(
    snackBar: MatSnackBar,
    private gymFinderService: GymFinderService
  ) {
    super(snackBar);
  }

  get slug() {
    return this.importForm.get('slug');
  }

  public importGym() {
    if (!this.importForm.valid) {
      this.openSnackBar('Invalid form');
      return;
    }

    this.loading = true;

    const { slug } = this.importForm.value;
    const slugs = {
      slug: slug || '',
    };

    this.gymFinderService.importGym(+this.gymId, slugs).subscribe({
      next: value => {
        this.gymChange.emit(value);
        this.loading = false;
      },
      error: (e: HttpErrorResponse) => {
        let errorMessage = '';
        if (e.status === 409) {
          errorMessage =
            'The city and name url slug combination of gym is not unique.';
        } else {
          errorMessage = 'Error occurred while importing gym!';
          if (e.error && e.error.message) {
            errorMessage = `${errorMessage} Reason: ${e.error.message}`;
          }
        }
        this.openSnackBar(errorMessage);
        this.loading = false;
      },
    });
  }

  get canImportGym(): boolean {
    return !isNaN(+this.gymId);
  }
}
